export default {
  setupDeepCloudBankAccountsPending: false,
  deepCloudLoginPending: false,
  deepCloudSyncPending: false,
  removeDeepCloudConnectionPending: false,
};
